var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import fetch from "../fetch";
var HOST_MAP = {
    'boe-sandbox': 'https://act-boe.bytedance.net',
    'boe-online': 'https://act-boe-cof.snssdk.com',
    'cn-sandbox': 'https://act-sandbox.nvsgames.cn',
    'cn-online': 'https://act.nvsgames.cn',
    'sg-sandbox': 'https://act-sandbox.sgsnssdk.com',
    'sg-online': 'https://act.toutiaocloud.com',
    'va-sandbox': 'https://act-sandbox.vasnssdk.com',
    'va-online': 'https://act.vasnssdk.com',
};
var autoEnv = function () {
    try {
        var origin_1 = location.origin;
        if (origin_1.indexOf('bytedance') > -1 || origin_1.indexOf('sandbox') > -1 || origin_1.indexOf('localhost') > -1) {
            return 'sandbox';
        }
        return 'online';
    }
    catch (_) {
        return 'sandbox';
    }
};
var getHost = function (options) {
    var host = '';
    if (options.env) {
        host = HOST_MAP["".concat(options.region, "-").concat(options.env)];
    }
    else {
        var auto = autoEnv();
        host = HOST_MAP["".concat(options.region, "-").concat(auto)];
    }
    return host;
};
export var getData = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var url, params, res, data, advs, banner, setting, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                url = getHost(options) + '/site/api/v2/picture/search';
                params = "?app_id=".concat(options.appId, "&website=").concat(options.website, "&page=").concat(options.page, "&block=").concat(options.block, "&channel=").concat(options.channel, "&language=").concat(options.language, "&page_size=").concat(options.pageSize || 99, "&page_index=").concat(options.pageIndex || 1);
                return [4 /*yield*/, window.fetch(url + params)];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                data = _a.sent();
                if (data.code !== 0) {
                    return [2 /*return*/, {
                            banner: null,
                            setting: null
                        }];
                }
                advs = data.data.advertisements || [];
                banner = advs.find(function (item) { return item.title === 'banner'; });
                setting = advs.find(function (item) { return item.title === 'setting'; });
                return [2 /*return*/, {
                        banner: banner,
                        setting: setting
                    }];
            case 3:
                e_1 = _a.sent();
                return [2 /*return*/, {
                        banner: null,
                        setting: null
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
export var getIpInfo = function (appId) { return __awaiter(void 0, void 0, void 0, function () {
    var originResult, result, _1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                return [4 /*yield*/, fetch.get("/external_activity/common/get_ip_info?app_id=".concat(appId))];
            case 1:
                originResult = _a.sent();
                return [4 /*yield*/, originResult.json()];
            case 2:
                result = _a.sent();
                return [2 /*return*/, result.data];
            case 3:
                _1 = _a.sent();
                return [2 /*return*/, {}];
            case 4: return [2 /*return*/];
        }
    });
}); };
//# sourceMappingURL=utils.js.map